module.exports = __webpack_public_path__ + "img/wedding_rings@2x.d392a56.webp";